export default __webpack_public_path__ + "static/pp-donatii-913556c8dcaacf15a5caa76a132dbcba.jpg";